import React from 'react';
import styles from './styles/FarewellDiagnosis.module.css';
import LogoSmiofi from '../../../assets/images/diagnosticos/SymbolBetaLight.svg';
import LogoGrowtty from '../../../assets/images/Logo_Negro_Verde_3.webp';
export const FarewellDiagnosis = () => {
  return (
    <div className={styles.containerParentNode}>
      <div className={styles.containerFarewellDiagnosis}>
        <h2 className={styles.title}>
          ¡Tu inicio hacia la transformación digital con growtty ha comenzado!
        </h2>
        <div>
          <p>
            Hemos enviado los resultados a tu correo electrónico como un archivo
            PDF. Este informe te dará una visión inicial sobre cómo tu empresa
            se está desempeñando en el ámbito digital y qué primeros pasos
            podrías considerar para comenzar tu transformación digital.
          </p>
          <p>
            Si tienes preguntas después de revisar tu diagnóstico o si estás
            listo para dar los siguientes pasos hacia la transformación digital
            de tu empresa, estamos a solo un mensaje de distancia. ¡Estamos
            emocionados de ayudarte a crecer en el mundo digital!
          </p>
        </div>
        <div className={styles.containerInformation}>
          <h3 className={styles.subtitle}>Más información en:</h3>
          <p className={styles.text}>
            <b>Sitio web:</b>&nbsp;
            <a className={styles.urlWebSites} href={'https://www.growtty.com'}>
              https://www.growtty.com
            </a>
          </p>
          <p className={styles.text}>
            <b>Instagram:</b>&nbsp;
            <a
              className={styles.urlWebSites}
              href={'https://www.instagram.com/growttty/'}
            >
              https://www.instagram.com/growttty/
            </a>
          </p>
          <p className={styles.text}>
            <b>Facebook:</b>&nbsp;
            <a
              className={styles.urlWebSites}
              href={'https://www.facebook.com/profile.php?id=61557376898016'}
            >
              https://www.facebook.com/profile.php?id=61557376898016
            </a>
          </p>
          <p className={styles.text}>
            <b>Linkedin:</b>&nbsp;
            <a
              className={styles.urlWebSites}
              href={
                'https://www.linkedin.com/company/growtty-colombia/?viewAsMember=true'
              }
            >
              https://www.linkedin.com/company/growtty-colombia
            </a>
          </p>
        </div>
        <div className={styles.containerLogos}>
          <h3 className={styles.subtitle}>Desarrollado por:</h3>
          <p className={styles.textLogos}>
            Growtty&nbsp;{' '}
            <img
              className={styles.imgLogo}
              alt={'company-logo'}
              src={LogoGrowtty}
            />
            &nbsp;&nbsp;|&nbsp;&nbsp;Smiofi&nbsp;{' '}
            <img
              className={styles.imgLogo}
              alt={'company-logo'}
              src={LogoSmiofi}
            />
          </p>
        </div>
      </div>
    </div>
  );
};
